export default "__VITE_ASSET__CILv_Aw7__"